import map from 'lodash/map';

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import * as store from 'store';

import { BOOTSTRAP_CIS_FORM } from 'store/form';

import {
  getSamplesMean, getSamplesStdev
} from 'store/scenes/bootstrapCIs/samples/selectors';

import { getAlpha } from 'store/form/bootstrapCIs/selectors';

import RightPaneComponent from './Component';
import { getPrimaryParameter } from 'store/scenes/bootstrapCIs/primaryParameter/selectors';
import { getSecondaryParameter } from 'store/scenes/bootstrapCIs/secondaryParameter/selectors';
import { getPrimaryParameterLevel } from 'store/scenes/bootstrapCIs/primaryParameterLevel/selectors';

class RightPaneContainer extends React.PureComponent {
  constructor (props) {
    super(props);

    this.handleDotClick = ({ target: { __data__: { id } } }) => {
      this.props.setSelectedSampleId(id);
    };
  }

  get dots () {
    return map(this.props.values,
      (value, id) => ({ id, value })
    );
  }

  get tailTypeRadioButtonProps () {
    return {
      getAlpha,

      form: BOOTSTRAP_CIS_FORM,

      mean: this.props.mean,
      stdev: this.props.stdev
    };
  }

  render () {
    const { tailType } = this.props;

    return (
      <RightPaneComponent
        mean={this.props.mean}
        stdev={this.props.stdev}
        amount={this.props.amount}

        dots={this.dots}

        testSelection={this.props.testSelection}
        selectedSampleId={this.props.selectedSampleId}
        tailTypeRadioButtonProps={this.tailTypeRadioButtonProps}
        measurement={this.props.measurement}

        leftCutoff={
          tailType === 'left' || tailType === 'both'
            ? this.props.leftCutoff
            : -Infinity
        }

        rightCutoff={
          tailType === 'right' || tailType === 'both'
            ? this.props.rightCutoff
            : +Infinity
        }

        onDotClick={this.handleDotClick}
      />
    );
  }
}

RightPaneContainer.propTypes = {
  values: PropTypes.arrayOf(
    PropTypes.number.isRequired
  ).isRequired,

  mean: PropTypes.number.isRequired,
  stdev: PropTypes.number.isRequired,
  amount: PropTypes.number.isRequired,

  tailType: PropTypes.string.isRequired,

  leftCutoff: PropTypes.number.isRequired,
  rightCutoff: PropTypes.number.isRequired,

  selectedSampleId: PropTypes.number.isRequired,
  setSelectedSampleId: PropTypes.func.isRequired,

  testSelection: PropTypes.string.isRequired,
  measurement: PropTypes.string.isRequired
};

const {
  scenes: {
    bootstrapCIs: {
      selectedSampleId: {
        getSelectedSampleId,
        setSelectedSampleId
      },

      testSelection: {
        getCapitalizedTestSelection
      }
    }
  }
} = store;


const mapStateToProps = state => {
  const values = store.scenes.bootstrapCIs.samples.getValues(state);

  const leftCutoff = store.form.bootstrapCIs.getLeftCutoff(state) || -Infinity;
  const rightCutoff = store.form.bootstrapCIs.getRightCutoff(state) || +Infinity;

  const tailType = store.form.bootstrapCIs.getTailType(state);

  const amount = store.scenes.bootstrapCIs.samples.getSamplesAmount(state);

  const selectedSampleId = getSelectedSampleId(state);

  let measurement = getPrimaryParameter(state).name;
  if (getSecondaryParameter(state).name.length > 0) {
    measurement = (`(${getPrimaryParameter(state).name}~${getSecondaryParameter(state).name})`);
  } else if (getPrimaryParameterLevel(state).length > 0) {
    measurement = (`(${getPrimaryParameter(state).name} = '${getPrimaryParameterLevel(state)}')`);
  }

  return {
    mean: getSamplesMean(state),
    stdev: getSamplesStdev(state),
    amount,

    values,

    leftCutoff,
    rightCutoff,

    tailType,

    selectedSampleId,

    testSelection: getCapitalizedTestSelection(state),
    measurement
  };
};

const mapDispatchToProps = {
  setSelectedSampleId
};

export default reduxForm({ form: BOOTSTRAP_CIS_FORM, destroyOnUnmount: false })(
  connect(mapStateToProps, mapDispatchToProps)(RightPaneContainer)
);
